const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-banner-block'] = {
        c: () => require('partner/modules/dlvry-banner-block/dlvry-banner-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-banner-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-banner-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dlvry-banner-block|dlvry-banner-block'] = {
                c: () => require('partner/modules/dlvry-banner-block/dlvry-banner-block.view.tsx'),
                cn: '__local__-__local__-dlvry-banner-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };